export default "__VITE_ASSET__CXo3d7R1__"